module.exports = __webpack_public_path__ + "static/bootstrap-7321a5c4e2a5df026a063e326b36bfe9.png";